import axios from 'axios';
import {setCookie,getCookie,delete_cookie} from '../utils/setCookie';
import config from '../utils/config';
import { jsonHeaders, API_TIMEOUT_MS } from '../utils/requestConfig';
import safeStorage from '../utils/safeStorage';
import { trustedPanelHost } from '../utils/apiHost';

// Console helper for dev/QA; never expose it in a production bundle.
if (process.env.NODE_ENV !== 'production') {
  window.setTempUIVersion = v => {
    const writeResult = safeStorage.setItem('set-temp-UIVersion', v);
    const rty = safeStorage.getItem('set-temp-UIVersion');
    if (writeResult === null || rty !== String(v)) {
      console.warn('Temp UI version could not be saved.');
      return;
    }
    console.log(`New temp UI version ${rty} saved. Reload to use it.`)
  }
}
  
// A missing, empty or foreign panel cookie falls back to the default host: the cookie picks the
// host that every signed-in request, the login form and the avatar uploads go to, so it must name
// a TGM API host (SE-PANEL-HOST-TOKEN, see config.isTrustedApiHost).
const cookiePanel = getCookie('panel');
const panelHost = trustedPanelHost(cookiePanel);
if(panelHost !== cookiePanel){
  delete_cookie('panel');
  setCookie('panel', config.urlGgCloud,365)
  const user_lang= "en"
  setCookie('panel_langauge', user_lang,365)
}

console.log('API.JS called')
// No Authorization here: the session headers are added per request by the request interceptor
// (utils/interceptor.js), which reads the token current at that moment (PANEL-1555).
export default axios.create({
    // panelHost, never a re-read: a planted cookie on another path or domain survives delete_cookie.
    baseURL: config.generateUrl(panelHost) + `/tgm-api/`,
    headers: jsonHeaders(),
    timeout: API_TIMEOUT_MS,
});
